<script setup>
import Locator from 'assets/icons/locator.svg'
import Right from 'assets/icons/right.svg'

defineProps({
    centerRouteLinkConfig: {
        type: Object,
        required: true,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                label: rawValue => rawValue?.label === undefined || typeof rawValue.label === 'string',
                link: rawValue => rawValue?.link === undefined || typeof rawValue.link === 'string',

            }

            return Object.values(validations).every(validation => validation(rawValue))
        }
    }
})
// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Fetch center details
const { data: centerDetails, suspense: centerDetailSuspense } = useFetchCenterDetails(centerRoute.value)

onServerPrefetch(async () => {
    await centerDetailSuspense()
})

// Track user click
const trackClicks = (type) => {
    trackUserClick({
        eventName: TRACKING_CONSTANTS.CLICK_EVENTS.CENTER_CONTACT_CLICK,
        centerUid: centerDetails.value?.centerUid,
        centerName: centerDetails.value?.centerName,
        contactType: type,
        screenName: TRACKING_CONSTANTS.MISC.CENTER_DETAILS,
    })
}
</script>

<template>
    <NuxtLink
        :to="centerRouteLinkConfig?.link"
        :title="centerRouteLinkConfig?.label"
        class="route-link-wrapper"
        target="_blank"
        rel="noopener noreferrer"
        @click="trackClicks('route')"
    >
        <Locator class="route-link-locator-icon" />
        <address>{{ centerRouteLinkConfig?.address }}</address>
        <Right class="route-link-arrow-icon" />
    </NuxtLink>
</template>

<style lang="scss">
.route-link-wrapper {
    padding: 15px 20px;
    border-radius: 24px;
    background: $route-link-wrapper-bg;
    text-decoration: none;
    color: inherit;
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
    flex-flow: row wrap;
    justify-content: space-between;
    transition: background-color 400ms ease-in-out;

    &:hover {
        background: $route-link-wrapper-bg-hover;
    }

    address {
        width: calc(100% - 60px);
        font-style: normal;
        cursor: pointer;

        @include body1-medium($lh: 1.3);
    }
}

.route-link-locator-icon {
    width: 18px;
    height: 24px;
}

.route-link-arrow-icon {
    width: 8px;
    height: 14px;
}
</style>
